/**
 * 약관관리 (/adm/terms) — 버전관리 · 통합반영 · 예정이력 · 약관별 동의자 탭
 * ($j.Pages.Admin.Terms / body data-page-name="Terms")
 *
 * 예전 blade 인라인 스크립트를 로직 그대로 옮겼다. DataTables·모달이 그리는 버튼은 onclick 대신
 * data-tm="동작"(+ data-n 인자)을 달고, initialize() 의 위임 바인딩 하나가 받는다 (CLICK·CHANGE 표).
 * 마크업·스타일은 adm/pages/terms/*.blade.php · sass/admin/pages/_terms.scss.
 */

let $termsTable = null;
let $versionTable = null;
let SELECTED_TERMS = null; // 선택된 약관 마스터 정보
let SELECTED_ROW = -1;     // 선택된 좌측 행 index (우측 패널의 전문보기·동의자가 참조)

// ── 약관 목록 DataTable ──
function loadTermsTable() {
    if ($termsTable) {
        $termsTable.destroy();
        $('#termsTable').empty();
    }

    $termsTable = new DataTable('#termsTable', {
        // 전문보기는 열로 두지 않는다 — 약관 이름을 누르면 우측 상세에서 본다
        columns: [
            { data: 'name', title: '약관이름',
                render: function (data, type, row, meta) {
                    if (type !== 'display') return data;
                    return `<a href="#" class="terms-name" data-tm="selectTerms" data-n="${meta.row}" title="상세·버전관리 열기">${data}</a>`;
                }
            },
            // 약관코드 — 이름은 사람이 부르는 말이고 코드는 앱·API 가 쓰는 값이라 둘이 짝이다.
            // 우측 상세에만 있으면 "이 코드가 어느 약관이지"를 하나씩 눌러 봐야 알 수 있었다.
            // 검색창은 전 컬럼을 훑으므로 코드로도 바로 찾아진다.
            { data: 'code', title: '약관코드', width: '160px',
                render: function (data, type) {
                    if (type !== 'display') return data;
                    return `<span class="terms-code">${escHtml(data || '')}</span>`;
                }
            },
            { data: '_service', title: '서비스', width: '90px',
                render: function (data, type) {
                    if (type !== 'display') return data; // 필터/정렬은 원본값 사용
                    const color = { '장비불러': 'var(--tm-app-jb)', '악덕알리미': 'var(--tm-app-bd)', '머큐리': 'var(--tm-app-mc)' };
                    return `<span class="badge" style="color:${color[data] || 'var(--tm-gray)'}">${data}</span>`;
                }
            },
            { data: '_category', title: '분류', width: '80px',
                render: function (data, type, row) {
                    const cls = { '가입': 'badge-join', '마케팅': 'badge-marketing', '오더별': 'badge-order' };
                    return `<span class="badge badge-cat ${cls[data] || ''}">${data}</span>`;
                }
            },
            // 필수·철회·현행버전·동의이력은 열로 두지 않는다 — 약관을 고르면 우측 상세에 다 나온다.
            // 선택 여부에 따라 열을 여닫으면 표 너비가 출렁여서, 처음부터 접힌 구성으로 고정한다.
            // 버전관리는 약관 이름 클릭, 동의자는 우측 패널 버튼으로 간다 — 여기엔 수정만 남긴다
            { data: null, title: '', width: '70px',
                render: function (data, type, row, meta) {
                    return `<button class="btn btn-warning btn-xs" data-tm="editMaster" data-n="${meta.row}">수정</button>`;
                }
            }
        ],
        ajax: {
            url: '/adm/ajax/config/terms/list',
            type: 'post'
        },
        columnDefs: [{ targets: '_all', className: 'text-center' }],
        processing: true,
        serverSide: false,
        ordering: false,
        searching: true,
        pageLength: 20,
        lengthChange: false,
        language: {
            search: '검색:',
            emptyTable: '등록된 약관이 없습니다.',
            zeroRecords: '일치하는 결과가 없습니다.',
        },
    });

    // 검색 영역(DataTables 2.x: div.dt-search)에 서비스 필터 + 약관추가 버튼을 한 줄로 배치
    const $ts = $('#termsTable').closest('.dt-container').find('.dt-search');
    $ts.css({ display: 'flex', alignItems: 'center', gap: '8px' });
    // 서비스 필터 (검색창 좌측). 클라이언트 컬럼 검색 — 서비스 컬럼 index 2.
    // ⚠ 위 columns 순서를 바꾸면 이 번호도 같이 고쳐야 한다 (열을 넣고 안 고쳐서 분류로 검색된 적 있다).
    $ts.prepend(
        '<select id="filterService" class="form-control input-sm" style="width:auto;">'
        + '<option value="">서비스 전체</option>'
        + '<option value="장비불러">장비불러</option>'
        + '<option value="악덕알리미">악덕알리미</option>'
        + '<option value="머큐리">머큐리</option>'
        + '<option value="이노페이">이노페이</option>'
        + '</select>'
    );
    $('#filterService').on('change', function () {
        $termsTable.column(2).search(this.value).draw();
    });
    $ts.append('<button class="btn btn-primary btn-sm" data-tm="showMasterModal" style="white-space:nowrap"><i class="fas fa-plus"></i> 약관 추가</button>');
}

// ── 약관 선택 → 상세 + 버전 목록 로드 ──
function selectTerms(rowIndex) {
    SELECTED_TERMS = $termsTable.row(rowIndex).data();
    SELECTED_ROW = rowIndex;
    $('#versionEmpty').hide();
    $('#versionBody').show();
    $('#versionPaneTitle').text('버전관리 — ' + (SELECTED_TERMS.name || ''));
    renderTermsMeta(rowIndex);
    loadVersionTable(SELECTED_TERMS.num);
}

// 우측 패널의 동의자 버튼 — 선택된 약관 기준
function showSelectedConsentLog() {
    if (SELECTED_ROW >= 0) showConsentLog(SELECTED_ROW);
}

/* 약관 상세 — 목록 열에서 뺀 약관코드와 전문보기를 여기서 본다. */
function renderTermsMeta(rowIndex) {
    const r = $termsTable.row(rowIndex).data();
    const view = r.ver_num
        ? `<button class="btn btn-default btn-xs" data-tm="viewVersion" data-n="${rowIndex}"><i class="fas fa-file-alt"></i> 전문보기</button>`
        : '<span class="text-danger">등록된 버전 없음</span>';

    // 한 항목당 한 행 — 값 옆에 이것저것 붙이면 행 높이가 달라져 라벨과 줄이 어긋난다
    $('#termsMeta').html(
        '<dl>'
        + `<dt>약관코드</dt><dd class="code">${escHtml(r.code || '')}</dd>`
        + `<dt>서비스</dt><dd>${escHtml(r._service || '')}</dd>`
        + `<dt>분류</dt><dd>${escHtml(r._category || '')}`
        + `<span class="badge ${r._required === '필수' ? 'badge-required' : 'badge-optional'}">${escHtml(r._required || '')}</span></dd>`
        + `<dt>철회</dt><dd>${escHtml(r._withdrawable || '')}</dd>`
        + `<dt>현행버전</dt><dd>${r.ver_num ? '<b>v' + escHtml(String(r.version_no)) + '</b>' : ''}${view}</dd>`
        + '</dl>'
    );
}

// 동의이력 클릭 → 약관별 동의 이력 모달 (DataTable serverSide 페이징 + 검색)
let $consentModalTable = null;
let CONSENT_TERMS_NUM = 0;
function showConsentLog(rowIndex) {
    const row = $termsTable.row(rowIndex).data();
    CONSENT_TERMS_NUM = row.num;
    const shell = `
        <div style="margin-bottom:10px; display:flex; gap:6px; flex-wrap:wrap; align-items:center">
            <input id="cm_kw" class="form-control input-sm" style="width:180px" placeholder="회원명" onkeypress="if(event.key==='Enter')reloadConsentModal()">
            <select id="cm_result" class="form-control input-sm" style="width:110px">
                <option value="">결과 전체</option><option value="1">동의</option><option value="2">거부</option><option value="3">철회</option>
            </select>
            <button class="btn btn-primary btn-xs" data-tm="reloadConsentModal"><i class="fas fa-search"></i> 검색</button>
            <button class="btn btn-default btn-xs" data-tm="resetConsentModal">초기화</button>
        </div>
        <table id="consentModalTable" class="table table-bordered display" style="width:100%"></table>`;
    $j.Ui.JBModal.html('consentLogModal', shell, `동의 이력 — ${escHtml(row.name)}`, { width: '900px' });

    if ($consentModalTable) { try { $consentModalTable.destroy(); } catch (e) {} }
    const cmap = { '동의': 'var(--tm-ok)', '거부': 'var(--tm-no)', '철회': 'var(--tm-wd)' };
    $consentModalTable = new DataTable('#consentModalTable', {
        ajax: {
            url: '/adm/ajax/terms/consent/logs', type: 'post',
            data: function (d) {
                d.terms_num = CONSENT_TERMS_NUM;
                d.mb_name = $('#cm_kw').val();
                d.consent_result = $('#cm_result').val();
            }
        },
        columns: [
            { data: 'consented_at', title: '일시', width: '180px', render: v => $j.Common.Util.formatDateTime(v) },
            { data: 'mem_name', title: '회원', width: '190px',
                render: (data, type, row) => $j.F.Admin.Member.Pop.cell(row.mb_no, data)
            },
            { data: 'version', title: '버전', width: '175px', render: v => v ? $j.Common.Util.formatDateTime(v) : '-' },
            { data: '_consent', title: '결과', width: '100px',
                render: d => `<span class="badge" style="color:${cmap[d] || 'var(--tm-gray)'}">${d}</span>` },
            { data: 'trigger_type', title: '경로', width: '130px',
                render: d => d ? `<span class="consent-path" title="${escHtml(d)}">${escHtml(d)}</span>`
                              : '<span class="consent-path">-</span>' },
        ],
        columnDefs: [{ targets: '_all', className: 'text-center' }],
        processing: true, serverSide: true, ordering: false, searching: false,
        pageLength: 20, lengthChange: false,
        language: {
            emptyTable: '동의 이력이 없습니다.', zeroRecords: '일치하는 결과가 없습니다.',
            info: '총 _TOTAL_건 중 _START_ ~ _END_', infoEmpty: '0건', processing: '불러오는 중…',
            paginate: { previous: '이전', next: '다음' },
        }
    });
}
function reloadConsentModal() { if ($consentModalTable) $consentModalTable.ajax.reload(); }

/* ═══════════ 약관별 동의자 탭 ═══════════
   좌: 약관 목록(약관이름 클릭) → 우: 그 약관의 동의자 목록.
   버전관리 탭과 같은 2분할 구조라 목록·검색 방식이 화면마다 달라지지 않는다. */
let $consentTermsTable = null;
let $consentTable = null;
let CONSENT_TAB_NUM = 0;   // 우측에 띄운 약관 번호

function loadConsentTermsTable() {
    if ($consentTermsTable) return;   // 탭 전환마다 다시 만들지 않는다
    $consentTermsTable = new DataTable('#consentTermsTable', {
        columns: [
            { data: 'name', title: '약관이름',
                render: (data, type, row, meta) => type !== 'display' ? data
                    : `<a href="#" class="terms-name" data-tm="selectConsentTerms" data-n="${meta.row}" title="동의자 보기">${data}</a>`
            },
            { data: '_service', title: '서비스', width: '90px',
                render: function (data, type) {
                    if (type !== 'display') return data;
                    const color = { '장비불러': 'var(--tm-app-jb)', '악덕알리미': 'var(--tm-app-bd)', '머큐리': 'var(--tm-app-mc)' };
                    return `<span class="badge" style="color:${color[data] || 'var(--tm-gray)'}">${data}</span>`;
                }
            },
            { data: '_category', title: '분류', width: '80px',
                render: function (data) {
                    const cls = { '가입': 'badge-join', '마케팅': 'badge-marketing', '오더별': 'badge-order' };
                    return `<span class="badge badge-cat ${cls[data] || ''}">${data}</span>`;
                }
            },
            { data: 'consent_cnt', title: '동의건수', width: '210px',
                render: function (data, type, row) {
                    const total = parseInt(data || 0, 10);
                    if (type !== 'display') return total;                 // 정렬·검색은 숫자 그대로
                    if (!total) return '<span style="color:var(--g400)">0건</span>';
                    const n = v => parseInt(v || 0, 10).toLocaleString();
                    // 결과별 건수는 0 이어도 보여준다 — 없는 건지 안 나온 건지 헷갈리지 않게
                    return `<b>${n(total)}건</b>`
                        + '<div class="consent-breakdown">'
                        +   `<span class="ok">동의 ${n(row.consent_agree)}</span>`
                        +   `<span class="no">거부 ${n(row.consent_deny)}</span>`
                        +   `<span class="wd">철회 ${n(row.consent_withdraw)}</span>`
                        + '</div>';
                }
            },
        ],
        ajax: { url: '/adm/ajax/config/terms/list', type: 'post' },
        columnDefs: [{ targets: '_all', className: 'text-center' }],
        processing: true, serverSide: false, ordering: false, searching: true,
        pageLength: 20, lengthChange: false,
        language: {
            search: '검색:', emptyTable: '등록된 약관이 없습니다.', zeroRecords: '일치하는 결과가 없습니다.',
        },
    });
}

// 약관 선택 → 우측에 동의자 목록
function selectConsentTerms(rowIndex) {
    const row = $consentTermsTable.row(rowIndex).data();
    CONSENT_TAB_NUM = row.num;
    $('#consentEmpty').hide();
    $('#consentBody').show();
    $('#consentPaneTitle').text('동의자 — ' + (row.name || ''));

    if ($consentTable) { $consentTable.destroy(); $('#consentTable').empty(); }
    const cmap = { '동의': 'var(--tm-ok)', '거부': 'var(--tm-no)', '철회': 'var(--tm-wd)' };
    $consentTable = new DataTable('#consentTable', {
        ajax: {
            url: '/adm/ajax/terms/consent/logs', type: 'post',
            data: function (d) {
                d.terms_num = CONSENT_TAB_NUM;
                d.mb_name = $('#ct_kw').val();
                d.consent_result = $('#ct_result').val();
            }
        },
        columns: [
            { data: 'consented_at', title: '일시', width: '180px', render: v => $j.Common.Util.formatDateTime(v) },
            { data: 'mem_name', title: '회원', width: '190px',
                render: (data, type, row) => $j.F.Admin.Member.Pop.cell(row.mb_no, data)
            },
            { data: 'version', title: '버전', width: '175px', render: v => v ? $j.Common.Util.formatDateTime(v) : '-' },
            { data: '_consent', title: '결과', width: '100px',
                render: d => `<span class="badge" style="color:${cmap[d] || 'var(--tm-gray)'}">${d}</span>` },
            { data: 'trigger_type', title: '경로', width: '130px',
                render: d => d ? `<span class="consent-path" title="${escHtml(d)}">${escHtml(d)}</span>`
                              : '<span class="consent-path">-</span>' },
        ],
        columnDefs: [{ targets: '_all', className: 'text-center' }],
        processing: true, serverSide: true, ordering: false, searching: false,
        pageLength: 20, lengthChange: false,
        language: {
            emptyTable: '동의 이력이 없습니다.', zeroRecords: '일치하는 결과가 없습니다.',
            info: '총 _TOTAL_건 중 _START_ ~ _END_', infoEmpty: '0건', processing: '불러오는 중…',
            paginate: { previous: '이전', next: '다음' },
        }
    });
}

function reloadConsentTab() { if ($consentTable) $consentTable.ajax.reload(); }

// 현행버전(v번호) 클릭 → 편집이 아니라 읽기전용으로 현행 본문만 보여준다.
function viewVersion(rowIndex) {
    const row = $termsTable.row(rowIndex).data();
    if (!row || !row.ver_num) return;
    $.post('/adm/ajax/terms/consent/preview', { ver_num: row.ver_num }, function (res) {
        if (!res || !res.result) { alert('본문을 불러오지 못했습니다.'); return; }
        const copyBar = res.html
            ? `<div style="display:flex;justify-content:flex-end;padding:10px 18px 0"><button type="button" class="btn btn-default btn-sm" data-tm="copyTermsText"><i class="far fa-copy"></i> 전문 복사</button></div>`
            : '';
        $j.Ui.JBModal.html('versionViewModal',
            copyBar
            + `<div class="terms-fulltext" style="max-height:calc(70vh / var(--adm-zoom, 1));overflow:auto;padding:14px 18px;font-size:16px;line-height:1.8;color:var(--adm-n-ink)">${res.html || '<span style="color:var(--adm-n-faint)">내용 없음</span>'}</div>`,
            `현행 v${res.version_no || row.version_no} — ${escHtml(row.name)}`, { width: '760px' });
    }, 'json');
}

// 전문 복사 — 드래그 복사는 <ol>/<ul> 의 번호·글머리 기호를 빼먹는다(브라우저가 그리는 것이라 글자가 아니다).
// 그래서 화면에 보이는 그대로 번호·기호를 글자로 붙인 텍스트를 직접 만들어 복사한다.
function copyTermsText(btn) {
    const box = $(btn).closest('.ui-modal__body').find('.terms-fulltext')[0];
    if (!box) return;
    const text = termsPlainText(box);
    const done = () => $j.Common.Util.tsalert('success', '전문을 복사했습니다.');
    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(done, () => copyTermsFallback(text, done));
    } else {
        copyTermsFallback(text, done);
    }
}

function copyTermsFallback(text, done) {
    const $t = $('<textarea>').val(text).css({ position: 'fixed', top: '-9999px' }).appendTo('body');
    $t[0].select();
    try { document.execCommand('copy') ? done() : alert('복사하지 못했습니다.'); } catch (e) { alert('복사하지 못했습니다.'); }
    $t.remove();
}

/** 본문 DOM → 줄바꿈·목록 번호·글머리 기호를 살린 텍스트. 표는 칸을 탭으로 잇는다. */
function termsPlainText(root) {
    const BLOCK = /^(P|DIV|H[1-6]|LI|UL|OL|TABLE|TR|BLOCKQUOTE|PRE|SECTION|ARTICLE|HEADER|FOOTER|DL|DT|DD|HR)$/;
    let out = '';
    const nl = () => { if (out && !out.endsWith('\n')) out += '\n'; };

    const olMarker = (ol, idx) => {
        const n = (parseInt(ol.getAttribute('start'), 10) || 1) + idx;
        const type = ol.getAttribute('type') || getComputedStyle(ol).listStyleType;
        if (type === 'a' || type === 'lower-alpha' || type === 'lower-latin') return String.fromCharCode(96 + n) + '.';
        if (type === 'A' || type === 'upper-alpha' || type === 'upper-latin') return String.fromCharCode(64 + n) + '.';
        if (type === 'hangul') return ('가나다라마바사아자차카타파하'[n - 1] || n) + '.';
        return n + '.';
    };
    const ulMarker = (ul, depth) => {
        const type = getComputedStyle(ul).listStyleType;
        if (type === 'none') return '';
        if (type === 'circle') return '◦';
        if (type === 'square') return '▪';
        return depth > 0 ? '◦' : '•';
    };

    const walk = (node, depth) => {
        if (node.nodeType === 3) {
            let v = node.nodeValue.replace(/\s+/g, ' ');
            if (out === '' || /\s$/.test(out)) v = v.replace(/^ /, '');   // 줄머리·기호 뒤 공백 겹침 방지
            out += v;
            return;
        }
        if (node.nodeType !== 1) return;
        const tag = node.tagName;
        if (tag === 'BR') { out += '\n'; return; }
        if (tag === 'SCRIPT' || tag === 'STYLE') return;

        if (tag === 'OL' || tag === 'UL') {
            nl();
            const items = Array.from(node.children).filter(c => c.tagName === 'LI');
            items.forEach((li, i) => {
                nl();
                const mark = tag === 'OL' ? olMarker(node, i) : ulMarker(node, depth);
                out += '  '.repeat(depth) + (mark ? mark + ' ' : '');
                Array.from(li.childNodes).forEach(c => walk(c, depth + 1));
            });
            nl();
            return;
        }
        if (tag === 'TD' || tag === 'TH') {
            if (node.previousElementSibling) out += '\t';
            Array.from(node.childNodes).forEach(c => walk(c, depth));
            return;
        }

        const block = BLOCK.test(tag);
        if (block) nl();
        Array.from(node.childNodes).forEach(c => walk(c, depth));
        if (block) nl();
    };
    walk(root, 0);

    // 줄 끝 공백만 정리 — 줄 앞 공백은 목록 들여쓰기다
    return out.split('\n').map(l => l.replace(/ +\t/g, '\t').replace(/[ \t]+$/, '')).join('\n')
        .replace(/\n{3,}/g, '\n\n').trim();
}

// ── 버전 목록 DataTable ──
function loadVersionTable(termsNum) {
    if ($versionTable) {
        $versionTable.destroy();
        $('#versionTable').empty();
    }

    $versionTable = new DataTable('#versionTable', {
        columns: [
            { data: 'num', title: 'No', width: '50px' },
            { data: 'version_no', title: '버전명', width: '80px',
                render: function (data, type, row) {
                    // 버전명은 순차번호(v1·v2·v3). 날짜(등록일/적용일)는 보조 컬럼에 표기.
                    const ver = '<b>v' + data + '</b>';
                    return row.version ? ver + ' <span class="text-muted" style="font-size:11px" title="' + row.version + '"></span>' : ver;
                }
            },
            { data: 'status', title: '상태', width: '80px',
                render: function (data) {
                    if (data === 'CURRENT')   return '<span class="badge badge-current">현행</span>';
                    if (data === 'SCHEDULED') return '<span class="badge badge-upcoming">예정</span>';
                    return '<span class="badge badge-old">구버전</span>';
                }
            },
            { data: 'content_length', title: '본문크기', width: '80px',
                render: function (data) {
                    return data ? number_format(data) + '자' : '-';
                }
            },
            { data: 'created_at', title: '등록일', width: '95px', render: v => fmtCompactDate(v) },
            { data: 'effective_from', title: '적용일', width: '95px', render: v => fmtCompactDate(v) },
            { data: null, title: '', width: '230px',
                render: function (data, type, row) {
                    const isCur = row.is_current == 1;
                    const isUpcoming = !isCur && !(row.effective_from || '');   // 예정안
                    // 좁아지면 버튼이 줄바꿈되므로 flex 로 감싼다 — 인라인 나열은 두 줄이 될 때 서로 겹친다
                    const row_ = (html) => `<div class="btn-row">${html}</div>`;
                    if (isCur) {  // 현행: 본문편집만
                        return row_(`<button class="btn btn-primary btn-xs" data-tm="editContent" data-n="${row.num}">본문편집</button>`);
                    }
                    if (isUpcoming) {  // 예정: 변경예정안/반영/본문편집/삭제
                        return row_(`<button class="btn btn-info btn-xs" data-tm="showCompare" data-n="${row.num}">변경예정안</button>
                                <button class="btn btn-success btn-xs" data-tm="applyVersion" data-n="${row.num}">반영</button>
                                <button class="btn btn-primary btn-xs" data-tm="editContent" data-n="${row.num}">본문편집</button>
                                <button class="btn btn-danger btn-xs" data-tm="deleteVersion" data-n="${row.num}">삭제</button>`);
                    }
                    // 구버전: 삭제만
                    return row_(`<button class="btn btn-danger btn-xs" data-tm="deleteVersion" data-n="${row.num}">삭제</button>`);
                }
            }
        ],
        ajax: {
            url: '/adm/ajax/config/terms/version/list',
            type: 'post',
            data: function (d) {
                d.terms_num = termsNum;
            }
        },
        columnDefs: [{ targets: '_all', className: 'text-center' }],
        processing: true,
        serverSide: false,
        ordering: false,
        searching: true,
        pageLength: 10,
        lengthChange: false,
        language: {
            search: '검색:',
            emptyTable: '등록된 버전이 없습니다.',
        },
    });

    // 검색 영역에 버전 타이틀 + 새 버전 추가 버튼 삽입
    const $vs = $('#versionTable').closest('.dt-container').find('.dt-search');
    $vs.css({ display: 'flex', alignItems: 'center', gap: '8px' });
    $vs.prepend(`<span id="versionTitle" style="font-weight:700;font-size:17px;white-space:nowrap;margin-right:auto">[${SELECTED_TERMS.name}] 버전 목록</span>`);
    $vs.append('<button class="btn btn-success btn-sm" data-tm="showVersionModal" style="white-space:nowrap"><i class="fas fa-plus"></i> 새 버전 추가</button>');
}

// ── 약관 마스터 모달 HTML 생성 ──
function masterFormHtml(row) {
    const isEdit = !!row;
    return `
    <form id="masterForm">
        <input type="hidden" name="num" id="mf_num" value="${isEdit ? row.num : ''}">
        <div class="form-group">
            <label>약관코드 <small class="text-danger">* 영문 대문자+언더스코어</small></label>
            <input type="text" class="form-control" name="code" id="mf_code" placeholder="예: LOCATION_SERVICE"
                   value="${isEdit ? row.code : ''}" ${isEdit ? 'readonly' : ''} required>
        </div>
        <div class="form-group">
            <label>약관이름 <small class="text-danger">*</small></label>
            <input type="text" class="form-control" name="name" id="mf_name" value="${isEdit ? row.name : ''}" required>
        </div>
        <div style="display:flex; gap:10px;">
            <div style="flex:1;">
                <div class="form-group">
                    <label>서비스 <small class="text-danger">*</small></label>
                    <select class="form-control" name="service" id="mf_service">
                        <option value="JB" ${!isEdit || row.service === 'JB' ? 'selected' : ''}>장비불러 (JB)</option>
                        <option value="BD" ${isEdit && row.service === 'BD' ? 'selected' : ''}>악덕알리미 (BD)</option>
                        <option value="MC" ${isEdit && row.service === 'MC' ? 'selected' : ''}>머큐리 (MC)</option>
                        <option value="IP" ${isEdit && row.service === 'IP' ? 'selected' : ''}>이노페이 (IP)</option>
                    </select>
                </div>
            </div>
            <div style="flex:1;">
                <div class="form-group">
                    <label>분류 <small class="text-danger">*</small></label>
                    <select class="form-control" name="category" id="mf_category">
                        <option value="JOIN" ${isEdit && row.category === 'JOIN' ? 'selected' : ''}>가입 (JOIN)</option>
                        <option value="MARKETING" ${isEdit && row.category === 'MARKETING' ? 'selected' : ''}>마케팅 (MARKETING)</option>
                        <option value="ORDER" ${isEdit && row.category === 'ORDER' ? 'selected' : ''}>오더별 (ORDER)</option>
                        <option value="REPORT" ${isEdit && row.category === 'REPORT' ? 'selected' : ''}>제보 (REPORT)</option>
                        <option value="CORRECTION" ${isEdit && row.category === 'CORRECTION' ? 'selected' : ''}>정정 (CORRECTION)</option>
                        <option value="CARD" ${isEdit && row.category === 'CARD' ? 'selected' : ''}>카드 (CARD)</option>
                    </select>
                </div>
            </div>
        </div>
        <div style="display:flex; gap:10px;">
            <div style="flex:1;">
                <div class="form-group">
                    <label>필수여부</label>
                    <select class="form-control" name="is_required">
                        <option value="1" ${!isEdit || row.is_required == 1 ? 'selected' : ''}>필수</option>
                        <option value="0" ${isEdit && row.is_required == 0 ? 'selected' : ''}>선택</option>
                    </select>
                </div>
            </div>
            <div style="flex:1;">
                <div class="form-group">
                    <label>철회가능</label>
                    <select class="form-control" name="is_withdrawable">
                        <option value="0" ${!isEdit || row.is_withdrawable == 0 ? 'selected' : ''}>불가</option>
                        <option value="1" ${isEdit && row.is_withdrawable == 1 ? 'selected' : ''}>가능</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="modal-actions">
            <button type="button" class="btn btn-secondary" data-tm="closeModal" data-modal="masterModal">취소</button>
            <button type="button" class="btn btn-primary" data-tm="saveMaster">저장</button>
        </div>
    </form>`;
}

// ── 약관 마스터 모달 (신규) ──
function showMasterModal() {
    $j.Ui.JBModal.html('masterModal', masterFormHtml(null), '약관 추가');
}

// ── 약관 마스터 모달 (수정) ──
function editMaster(rowIndex) {
    const row = $termsTable.row(rowIndex).data();
    $j.Ui.JBModal.html('masterModal', masterFormHtml(row), '약관 수정');
}

// ── 약관 마스터 저장 ──
function saveMaster() {
    $.ajax({
        type: 'POST',
        url: '/adm/ajax/config/terms/save',
        data: $('#masterForm').serialize(),
        success: function (res) {
            if (res.result) {
                $j.Ui.JBModal.close('masterModal');
                $termsTable.ajax.reload();
            } else {
                alert(res.message || '저장 실패');
            }
        }
    });
}

// ── 버전 추가 모달 HTML (버전명 자동 — 약관별 순차 v1·v2·v3) ──
function versionFormHtml(d) {
    return `
    <form id="versionForm" style="width:420px">
        <input type="hidden" name="terms_num" value="${SELECTED_TERMS.num}">
        <p style="color:var(--adm-n-text);margin-bottom:12px;line-height:1.7">
            현행 본문을 그대로 가져와 새 버전을 만듭니다.<br>
            버전 번호(v1·v2·v3…)는 저장할 때 자동으로 붙습니다.
        </p>
        <div class="form-group">
            <label>
                <input type="checkbox" name="is_current" id="vf_is_current" value="1" data-tm-change="updateVersionCurrentNote"> 저장하면서 바로 현행으로 바꾸기
            </label>
        </div>
        <p id="vf_current_note" style="color:var(--adm-n-text);margin-top:-6px;margin-bottom:12px;line-height:1.6;font-size:.9em;min-height:2.9em"></p>
        <div class="modal-actions">
            <button type="button" class="btn btn-secondary" data-tm="closeModal" data-modal="versionModal">취소</button>
            <button type="button" class="btn btn-primary" data-tm="saveVersion">저장</button>
        </div>
    </form>`;
}

// ── 체크박스 상태에 따라 저장 결과 안내 문구 갱신 ──
function updateVersionCurrentNote() {
    const $note = $('#vf_current_note');
    if (!$note.length) return;
    if ($('#vf_is_current').is(':checked')) {
        $note.html('<b>저장하는 순간 회원에게 이 내용이 보입니다.</b> 오늘 날짜가 적용시작일로 기록됩니다.');
    } else {
        $note.html('적용 대기 상태로만 저장됩니다. 회원에게는 아직 현행 버전이 보이고, 목록에서 <b>반영</b>을 누르거나 <b>약관 통합 반영</b>에서 누를 때 적용됩니다.');
    }
}

// ── 버전 추가 모달 ──
function showVersionModal() {
    if (!SELECTED_TERMS) return;
    $j.Ui.JBModal.html('versionModal', versionFormHtml(null), '새 버전 추가');
    updateVersionCurrentNote();
}

// ── 버전 수정 모달 ──
function editVersion(verNum) {
    $.ajax({
        type: 'POST',
        url: '/adm/ajax/config/terms/version/content',
        data: { ver_num: verNum },
        success: function (res) {
            if (!res.result) return;
            $j.Ui.JBModal.html('versionModal', versionFormHtml(res.data), '버전 수정');
            updateVersionCurrentNote();
        }
    });
}

// ── 버전 저장 ──
function saveVersion() {
    const data = $('#versionForm').serialize();
    const isCurrent = $('#vf_is_current').is(':checked') ? 1 : 0;

    $.ajax({
        type: 'POST',
        url: '/adm/ajax/config/terms/version/save',
        data: data + '&is_current=' + isCurrent + '&content=',
        success: function (res) {
            if (res.result) {
                $j.Ui.JBModal.close('versionModal');
                $versionTable.ajax.reload();
                $termsTable.ajax.reload();
            } else {
                alert(res.message || '저장 실패');
            }
        }
    });
}

// ── content JSON 파싱 (구버전 plain text/html 호환) ──
function parseContent(raw) {
    // 이미 object인 경우 (서버에서 JSON 파싱 후 내려온 경우)
    if (raw && typeof raw === 'object' && raw.type) return raw;
    // 문자열이면 제어문자 제거 후 JSON 파싱 시도
    if (typeof raw === 'string') {
        try {
            const cleaned = raw.replace(/[\x00-\x1F\x7F]/g, '');
            const obj = JSON.parse(cleaned);
            if (obj && obj.type) return obj;
        } catch (e) {}
    }
    // JSON이 아니면 html 타입으로 래핑
    return { type: 'html', body_html: raw || '' };
}

// ── 본문 편집 모달 ──
function editContent(verNum) {
    $.ajax({
        type: 'POST',
        dataType: 'json',
        url: '/adm/ajax/config/terms/version/content',
        data: { ver_num: verNum },
        success: function (res) {
            if (!res.result) return;
            const d = res.data;
            const content = parseContent(d.content);
            const isCur = d.is_current == 1;       // 현행 편집 = 예정버전 생성 모드

            const headerHtml = `
            <form id="editContentForm">
                <input type="hidden" name="ver_num" value="${d.num}">
                <input type="hidden" name="terms_num" value="${d.terms_num}">
                <div style="display:flex; gap:10px; margin-bottom:10px;">
                    <div style="flex:2;">
                        <label>버전명 <small class="text-muted">${isCur ? '(현행)' : '(예정/구버전)'}</small></label>
                        <input type="text" class="form-control" name="version" value="v${d.version_no}" readonly>
                    </div>
                    <div style="flex:1;">
                        <label>본문 유형</label>
                        <select class="form-control" id="ec_type" data-tm-change="toggleContentType">
                            <option value="html" ${content.type === 'html' ? 'selected' : ''}>HTML</option>
                            <option value="structured" ${content.type === 'structured' ? 'selected' : ''}>구조화 (항목형)</option>
                            <option value="articles" ${content.type === 'articles' ? 'selected' : ''}>조항형 (제N조)</option>
                        </select>
                    </div>
                </div>`;

            // ── HTML 편집 영역 ──
            const htmlEditor = `
                <div id="ec_area_html" style="display:${content.type === 'html' ? 'block' : 'none'};">
                    <div class="form-group">
                        <label>본문 (HTML)</label>
                        <textarea class="form-control" id="ec_body_html" rows="15" style="min-height:400px;font-size:16px;line-height:1.7;"></textarea>
                    </div>
                </div>`;

            // ── 구조화 편집 영역 ──
            const items = content.items || [];
            let itemsHtml = '';
            items.forEach(function (item, i) {
                itemsHtml += structuredItemRow(i, item.label, item.value);
            });

            const structuredEditor = `
                <div id="ec_area_structured" style="display:${content.type === 'structured' ? 'block' : 'none'};">
                    <div class="form-group">
                        <label>제목</label>
                        <input type="text" class="form-control" id="ec_s_title" value="">
                    </div>
                    <div class="form-group">
                        <label>항목 <button type="button" class="btn btn-default btn-xs" data-tm="addStructuredItem"><i class="fas fa-plus"></i> 추가</button></label>
                        <div id="ec_s_items">${itemsHtml}</div>
                    </div>
                    <div class="form-group">
                        <label>경고 문구</label>
                        <input type="text" class="form-control" id="ec_s_warning" value="">
                    </div>
                    <div class="form-group">
                        <label>동의 체크박스 문구</label>
                        <input type="text" class="form-control" id="ec_s_consent_label" value="">
                    </div>
                    <div class="form-group">
                        <label>상세 본문 (HTML, 선택)</label>
                        <textarea class="form-control" id="ec_s_body_html" rows="6" style="font-size:16px;line-height:1.7;"></textarea>
                    </div>
                </div>`;

            // ── 조항형(articles) 편집 영역 ──
            const articlesEditor = `
                <div id="ec_area_articles" style="display:${content.type === 'articles' ? 'block' : 'none'};">
                    <div class="ec-guide">
                        <div class="ec-guide-head" data-tm="toggleGuide">
                            <b>📘 조항형 사용법</b>
                            <i class="fas fa-chevron-down ec-guide-chev"></i>
                        </div>
                        <div class="ec-guide-body">
                            <ul style="margin:4px 0 0;padding-left:18px">
                                <li><b>key</b> — 버전 간 비교 기준(안정 키). 같은 조는 <u>버전이 바뀌어도 같은 key</u>로 유지하세요(예: <code>art2</code>). 조 번호가 바뀌어도 key가 같으면 '개정', key가 없거나 새로우면 '신설', 사라지면 '삭제'로 잡힙니다.</li>
                                <li><b>제N조 / 제목</b> — 표시용. (예: <code>제2조</code> / <code>약관의 효력 및 변경</code>)</li>
                                <li><b>항(본문)</b> — 한 줄에 하나씩(①②③ 또는 1. 2.). 줄바꿈이 항 구분. <u>이 본문을 직접 수정/추가/삭제하면 그게 개정 내용</u>이 됩니다.</li>
                            </ul>
                            <div style="margin-top:6px"><b>예정버전 만드는 법:</b> 현행 본문편집에서 <u>항(본문)을 직접 수정</u> → <span class="badge badge-current" style="font-size:13px">예정버전으로 적용</span> → 버전 행의 <span class="badge badge-current" style="font-size:13px">변경예정안</span> 으로 현행과 비교(변경사항은 자동: 신설/개정/삭제).</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px">
                            <label style="margin-bottom:0">조항</label>
                            <button type="button" class="btn btn-default btn-xs" data-tm="addArticle"><i class="fas fa-plus"></i> 조 추가</button>
                        </div>
                        <div class="ta-split">
                            <div class="ta-list">
                                <div style="margin-bottom:10px"><b style="font-size:14.5px">조 목록</b> <span id="ec_articles_count" style="font-size:12.5px;color:var(--tm-gray);font-weight:600"></span></div>
                                <div id="ec_articles_list"></div>
                            </div>
                            <div class="ta-detail">
                                <div id="ec_articles_empty" class="ta-empty">
                                    <i class="fas fa-hand-pointer"></i>
                                    <div>왼쪽에서 조를 클릭하면<br>여기에 상세 내용이 표시됩니다.</div>
                                </div>
                                <div id="ec_articles"></div>
                            </div>
                        </div>
                    </div>
                </div>`;

            const footerHtml = `
                <div class="modal-actions ec-content-foot" style="justify-content:space-between;">
                    <button type="button" class="btn btn-default" data-tm="previewContent"><i class="fas fa-eye"></i> 미리보기</button>
                    <div class="modal-actions" style="margin-top:0;">
                        <button type="button" class="btn btn-secondary" data-tm="closeModal" data-modal="contentModal">취소</button>
                        ${isCur ? '<button type="button" class="btn btn-success" data-tm="saveContentAsDraft">예정버전으로 적용</button>' : ''}
                        <button type="button" class="btn btn-primary" data-tm="saveContent">${isCur ? '현행 직접수정' : '저장'}</button>
                    </div>
                </div>
            </form>`;

            $j.Ui.JBModal.html('contentModal', headerHtml + htmlEditor + structuredEditor + articlesEditor + footerHtml,
                `본문 편집 — ${SELECTED_TERMS.name} (v${d.version_no})`, { width: '1240px' });
            syncContentModalScroll(content.type);

            // 값 설정 (XSS 방지를 위해 .val() 사용)
            if (content.type === 'html') {
                $('#ec_body_html').val(content.body_html);
            } else if (content.type === 'articles') {
                setArticleValues(content.articles || []);
            } else {
                $('#ec_s_title').val(content.title || '');
                $('#ec_s_warning').val(content.warning || '');
                $('#ec_s_consent_label').val(content.consent_label || '');
                $('#ec_s_body_html').val(content.body_html || '');
                setStructuredItemValues(content.items || []);
            }
            bindScrollJump('contentModal');
        }
    });
}

/* ── 본문편집 모달 스크롤 점프 버튼 ──────────────────────────
   조를 여러 개 추가하면 모달이 길어지므로 우하단에 플로팅 버튼을 띄운다.
   맨 위 근처면 '맨 아래로(↓)', 그 외에는 '맨 위로(↑)'. 스크롤이 없으면 숨김. */
function bindScrollJump(modalId) {
    const $modal = $('#' + modalId);
    const $body = $modal.find('.ui-modal__body');
    if (!$body.length || $modal.find('.ec-scrolljump').length) return;

    const $btn = $('<button type="button" class="ec-scrolljump"></button>').css({
        position: 'absolute', right: '18px', bottom: '64px',  // 저장 버튼 줄 위
        width: '38px', height: '38px', borderRadius: '50%',
        border: '1px solid #cfd6dd', background: 'rgba(255,255,255,.92)',
        boxShadow: '0 2px 8px rgba(0,0,0,.18)', color: 'var(--adm-c-34495e, #34495e)',
        cursor: 'pointer', display: 'none', zIndex: 5,
    });
    $modal.append($btn);

    const NEAR = 40;   // 맨 위로 간주할 여유
    const maxTop = () => $body[0].scrollHeight - $body[0].clientHeight;
    const atTop = () => $body.scrollTop() <= NEAR;

    const update = () => {
        if (maxTop() <= NEAR * 2) { $btn.hide(); return; }   // 스크롤할 게 없으면 숨김
        const down = atTop();
        $btn.show()
            .attr('title', down ? '맨 아래로' : '맨 위로')
            .html(`<i class="fas fa-arrow-${down ? 'down' : 'up'}"></i>`);
    };

    $btn.on('click', () => $body.stop().animate({ scrollTop: atTop() ? maxTop() : 0 }, 300));
    $body.on('scroll', update);
    update();
    _scrollJumpUpdate = update;   // 조 추가/삭제 후 갱신용
}

let _scrollJumpUpdate = null;
function refreshScrollJump() {
    if (_scrollJumpUpdate) _scrollJumpUpdate();
}

// ── 조항형(articles) 편집 헬퍼 — 좌: 조 목록, 우: 선택한 조 상세(클릭한 것만 표시) ──
let _articleSeq = 0;
let _selectedArticleId = null;
function articleRowHtml(a) {
    a = a || {};
    const id = ++_articleSeq;
    return `<div class="ec-article" data-aid="${id}" style="display:none">
        <div class="ec-a-head">
            <div class="ec-a-field ec-a-key"><label>key</label>
                <input class="form-control a-key" placeholder="예: art2" value="${escHtml(a.key || '')}"></div>
            <div class="ec-a-field ec-a-no"><label>제N조</label>
                <input class="form-control a-no" placeholder="제2조" value="${escHtml(a.no || '')}"></div>
            <div class="ec-a-field ec-a-title"><label>제목</label>
                <input class="form-control a-title" placeholder="약관의 효력 및 변경" value="${escHtml(a.title || '')}"></div>
            <button type="button" class="btn btn-danger btn-sm ec-a-del" data-tm="removeArticle" data-n="${id}"><i class="fas fa-trash"></i> 삭제</button>
        </div>
        <div class="ec-a-body">
            <label>항 — ①②③ 또는 1. 2. 한 줄에 하나씩</label>
            <textarea class="form-control a-clauses" rows="12" placeholder="① …&#10;② …" style="font-size:16px;line-height:1.8">${escHtml((a.clauses || []).join('\n'))}</textarea>
        </div>
    </div>`;
}
function setArticleValues(articles) {
    $('#ec_articles').html((articles && articles.length ? articles : [{}]).map(articleRowHtml).join(''));
    // 조가 1개뿐이어도 목록+안내문 상태로 시작한다 — 클릭해야 상세가 뜬다.
    selectArticle(null);
}
function addArticle() {
    const html = articleRowHtml({});
    $('#ec_articles').append(html);
    selectArticle(_articleSeq);   // 방금 추가한 조는 명시적 행동이니 바로 보여준다
}
function removeArticle(id) {
    $(`#ec_articles .ec-article[data-aid="${id}"]`).remove();
    let $remain = $('#ec_articles .ec-article');
    if (!$remain.length) { $('#ec_articles').append(articleRowHtml({})); $remain = $('#ec_articles .ec-article'); }
    selectArticle(+$remain.first().data('aid'));
}

// ── 목록에서 조 선택 — 선택한 카드만 보이고 나머지는 숨긴다. id 가 없으면(null) 안내문만 보인다. ──
function selectArticle(id) {
    _selectedArticleId = id;
    $('#ec_articles .ec-article').each(function () { $(this).toggle(+$(this).data('aid') === id); });
    $('#ec_articles_empty').toggleClass('on', id === null);
    renderArticlesList();
    refreshScrollJump();
}

// ── 좌측 조 목록 — 제N조/제목을 읽어 다시 그린다(입력할 때마다 라벨도 갱신) ──
function renderArticlesList() {
    const rows = $('#ec_articles .ec-article').map(function () {
        const $a = $(this);
        const id = +$a.data('aid');
        const no = $a.find('.a-no').val().trim();
        const title = $a.find('.a-title').val().trim() || '(제목 없음)';
        return `<div class="ta-row${id === _selectedArticleId ? ' on' : ''}" data-tm="selectArticle" data-n="${id}">
            ${no ? `<span class="ta-row-no">${escHtml(no)}</span>` : ''}
            <span class="ta-row-title">${escHtml(title)}</span>
        </div>`;
    }).get().join('');
    $('#ec_articles_list').html(rows);
    $('#ec_articles_count').text($('#ec_articles .ec-article').length ? `총 ${$('#ec_articles .ec-article').length}개` : '');
}

function collectArticles() {
    return $('#ec_articles .ec-article').map(function () {
        const $a = $(this);
        return {
            key: $a.find('.a-key').val().trim(),
            no: $a.find('.a-no').val().trim(),
            title: $a.find('.a-title').val().trim(),
            clauses: $a.find('.a-clauses').val().split('\n').map(s => s.trim()).filter(Boolean),
        };
    }).get();
}

// ── 구조화 항목 행 HTML ──
function structuredItemRow(idx, label, value) {
    return `
    <div class="ec-s-item" style="display:flex; gap:8px; margin-bottom:6px; align-items:center;">
        <input type="text" class="form-control ec-s-item-label" placeholder="항목명" value="" style="flex:1;">
        <input type="text" class="form-control ec-s-item-value" placeholder="내용" value="" style="flex:2;">
        <button type="button" class="btn btn-danger btn-xs" data-tm="removeStructuredItem"><i class="fas fa-times"></i></button>
    </div>`;
}

// ── 구조화 항목에 값 설정 (DOM 생성 후 호출) ──
// structuredItemRow에서 value=""로 생성 후 .val()로 설정하는 방식
function setStructuredItemValues(items) {
    $('#ec_s_items .ec-s-item').each(function (i) {
        if (items[i]) {
            $(this).find('.ec-s-item-label').val(items[i].label);
            $(this).find('.ec-s-item-value').val(items[i].value);
        }
    });
}

// ── 구조화 항목 추가 ──
function addStructuredItem() {
    $('#ec_s_items').append(structuredItemRow($('#ec_s_items .ec-s-item').length, '', ''));
}

// ── 유형 토글 ──
function toggleContentType() {
    const type = $('#ec_type').val();
    $('#ec_area_html').toggle(type === 'html');
    $('#ec_area_structured').toggle(type === 'structured');
    $('#ec_area_articles').toggle(type === 'articles');
    syncContentModalScroll(type);
}

// ── 조항형은 목록·상세 칸 안에서만 스크롤되는 고정 레이아웃이라 바깥(모달 본문)은 스크롤을 끈다.
//    html·구조화형은 내용 길이가 들쭉날쭉하므로 기존처럼 모달 본문이 스크롤된다. ──
function syncContentModalScroll(type) {
    $('#contentModal .ui-modal__body').css('overflow-y', type === 'articles' ? 'hidden' : 'auto');
}

// 편집창 내용 → content JSON 문자열
function buildContentStr() {
    const type = $('#ec_type').val();
    if (type === 'html') {
        return JSON.stringify({ type: 'html', body_html: $('#ec_body_html').val() });
    }
    if (type === 'articles') {
        return JSON.stringify({ type: 'articles', articles: collectArticles() });
    }
    const items = [];
    $('#ec_s_items .ec-s-item').each(function () {
        const label = $(this).find('.ec-s-item-label').val().trim();
        const value = $(this).find('.ec-s-item-value').val().trim();
        if (label || value) items.push({ label, value });
    });
    return JSON.stringify({
        type: 'structured',
        title: $('#ec_s_title').val().trim(),
        items: items,
        warning: $('#ec_s_warning').val().trim(),
        consent_label: $('#ec_s_consent_label').val().trim(),
        body_html: $('#ec_s_body_html').val()
    });
}

function _afterContentSave(res, msg) {
    if (!res.result) { alert(res.message || '저장 실패'); return; }
    $j.Ui.JBModal.close('contentModal');
    if ($versionTable) $versionTable.ajax.reload();
    $termsTable.ajax.reload(null, false);
    alert(msg);
}

// ── 미리보기 — 편집 중 내용을 사용자 화면과 동일하게 렌더 ──
function previewContent() {
    $.post('/adm/ajax/config/terms/preview', { content: buildContentStr() }, function (res) {
        if (!res.result) { alert(res.message || '미리보기 실패'); return; }
        $j.Ui.JBModal.html('previewModal',
            `<div style="max-height:calc(70vh / var(--adm-zoom, 1));overflow:auto;padding:14px 18px;font-size:16px;line-height:1.8;color:var(--adm-n-ink)">${res.html || '<span style="color:var(--adm-n-faint)">내용 없음</span>'}</div>`,
            '미리보기', { width: '760px' });
    }, 'json');
}

// ── 본문 저장 — 편집 중인 그 버전을 직접 수정 ──
function saveContent() {
    const $form = $('#editContentForm');
    $form.find('input[name="content"]').remove();
    $form.append('<input type="hidden" name="content">');
    $form.find('input[name="content"]').val(buildContentStr());
    $.ajax({
        type: 'POST', url: '/adm/ajax/config/terms/version/save', data: $form.serialize(),
        success: (res) => _afterContentSave(res, '저장되었습니다.')
    });
}

// ── 예정버전으로 적용 — 현행 본문편집 내용을 새 예정버전(비현행)으로 생성 ──
function saveContentAsDraft() {
    if (!confirm('현재 편집 내용을 예정버전으로 만듭니다.\n현행은 그대로 유지되고, 새 예정버전이 생성됩니다.')) return;
    $.post('/adm/ajax/config/terms/version/save',
        { terms_num: SELECTED_TERMS.num, content: buildContentStr() },  // ver_num 없음·is_current 0 → 새 예정버전
        (res) => _afterContentSave(res, '예정버전이 생성되었습니다. [변경예정안]에서 확인하세요.'), 'json');
}

// ── 변경예정안 (현행 vs 개정안 조항 비교표) ──
function showCompare(verNum) {
    $.post('/adm/ajax/config/terms/version/compare',
        { terms_num: SELECTED_TERMS.num, ver_num: verNum },
        function (res) {
            if (!res.result) { alert(res.message || '비교 실패'); return; }
            const applyBar = `<div class="compare-bar">
                <button class="btn btn-default" data-tm="downloadCompareImage"><i class="fas fa-image"></i> 다운받기</button>
                <button class="btn btn-success" data-tm="applyVersion" data-n="${verNum}"><i class="fas fa-check-circle"></i> 개정안 반영</button></div>`;
            const capture = `<div id="compareCapture" style="background:var(--adm-b-ffffff, #fff);padding:16px">
                <h4 style="margin:0 0 12px;font-weight:bold">변경예정안 — ${escHtml(SELECTED_TERMS.name)}</h4>
                ${renderCompareTable(res.rows)}</div>`;
            $j.Ui.JBModal.html('compareModal', capture + applyBar,
                `변경예정안 — ${SELECTED_TERMS.name}`, { width: '1040px' });
        }, 'json');
}

// 변경예정안 비교표를 이미지(PNG)로 저장 — 버튼바(반영/다운로드)는 제외하고 #compareCapture 만 캡처
async function downloadCompareImage(btn) {
    const $btn = $(btn);
    const old  = $btn.html();
    const target = document.getElementById('compareCapture');
    if (!target) return;
    $btn.prop('disabled', true).html('<i class="fas fa-spinner fa-spin"></i> 생성중…');
    try {
        await ensureH2C();
        // 캡처는 항상 흰 바탕 — 다크로 보고 있어도 내보낸 그림은 흰 종이여야 한다
        const canvas = await window.html2canvas(target, { scale: 2, backgroundColor: '#ffffff', useCORS: true, logging: false });
        const a = document.createElement('a');
        a.download = '변경예정안_' + (SELECTED_TERMS.name || '약관') + '.png';
        a.href = canvas.toDataURL('image/png');
        a.click();
    } catch (e) {
        alert('이미지 생성 실패: ' + (e && e.message ? e.message : e));
    } finally {
        $btn.prop('disabled', false).html(old);
    }
}

// html2canvas 지연 로드 — 로컬 vendor 파일을 필요할 때 1회만 삽입
function ensureH2C() {
    return new Promise((resolve, reject) => {
        if (window.html2canvas) return resolve();
        let s = document.querySelector('script[data-terms-h2c]');
        if (s) { s.addEventListener('load', () => resolve()); s.addEventListener('error', reject); return; }
        s = document.createElement('script');
        s.src = `/js/vendor/html2canvas.js?${G5['cacheVer']}`;
        s.async = true;
        s.setAttribute('data-terms-h2c', '1');
        s.onload  = () => resolve();
        s.onerror = () => reject(new Error('html2canvas 로드 실패'));
        document.head.appendChild(s);
    });
}

// 예정안/구버전 삭제 (현행·동의이력 버전은 서버에서 차단)
function deleteVersion(verNum) {
    if (!confirm('이 버전을 삭제합니다. 되돌릴 수 없습니다.\n진행할까요?')) return;
    $.post('/adm/ajax/config/terms/version/delete', { ver_num: verNum }, function (res) {
        if (!res.result) { alert(res.message || '삭제 실패'); return; }
        if ($versionTable) $versionTable.ajax.reload();
        $termsTable.ajax.reload(null, false);
        alert('삭제되었습니다.');
    }, 'json');
}

// 개정안 → 현행 반영 (기존 현행은 구버전이 됨)
function applyVersion(verNum) {
    if (!confirm('이 버전을 현행 약관으로 반영합니다.\n기존 현행 버전은 구버전이 되고, 사용자에게 즉시 노출됩니다.\n진행할까요?')) return;
    $.post('/adm/ajax/config/terms/version/apply', { ver_num: verNum }, function (res) {
        if (!res.result) { alert(res.message || '반영 실패'); return; }
        $j.Ui.JBModal.close('compareModal');
        if ($versionTable) $versionTable.ajax.reload();
        $termsTable.ajax.reload(null, false);
        alert('현행으로 반영되었습니다.');
    }, 'json');
}

function renderCompareTable(rows) {
    if (!rows || !rows.length) {
        return '<p style="padding:24px;text-align:center;color:var(--adm-c-888888, #888)">변경된 조항이 없습니다. (현행과 동일)</p>';
    }
    const badge = { '신설': 'badge-active', '개정': 'badge-current', '삭제': 'badge-inactive' };
    const clauses = (a) => (a && a.clauses && a.clauses.length)
        ? a.clauses.map(escHtml).join('<br>')
        : '<span style="color:#bbb">-</span>';
    const rowsHtml = rows.map(r => `<tr>
        <td style="vertical-align:top"><span class="badge ${badge[r.status] || ''}">${escHtml(r.status)}</span>
            <div style="margin-top:4px;font-weight:bold">${escHtml(r.no)}</div>
            <div style="color:var(--adm-c-666666, #666);font-size:14px">${escHtml(r.title)}</div></td>
        <td style="vertical-align:top;line-height:1.6">${clauses(r.current)}</td>
        <td style="vertical-align:top;line-height:1.6">${clausesDiff(r.current, r.draft)}</td>
        <td style="vertical-align:top;line-height:1.6;color:var(--adm-c-c0392b, #c0392b);white-space:pre-line">${escHtml(r.change_note)}</td>
    </tr>`).join('');
    return `<div style="margin:0 0 10px;font-size:14px;color:var(--adm-c-666666, #666)">개정(안) 열 표기 —
            <span style="color:${DEL_COLOR};text-decoration:line-through">삭제된 내용</span> ·
            <span style="color:${DIFF_COLOR}">새로 들어간 내용</span> ·
            <span style="color:${MOVE_COLOR}">[순서변경] 자리만 바뀐 항</span> ·
            <span style="color:${RENUM_COLOR}">[번호변경]·[항분할]·[항병합] 내용은 그대로고 형식만 바뀐 항</span>
        </div>
        <table class="table table-bordered" style="font-size:16px;table-layout:fixed">
        <thead><tr style="background:var(--adm-b-f5f5f5, #f5f5f5)">
            <th style="width:130px">구분</th><th>현행</th><th>개정(안)</th><th style="width:230px">변경사항</th>
        </tr></thead><tbody>${rowsHtml}</tbody></table>`;
}

/* ══ terms-diff:start ══════════════════════════════════════════════════════
   여기부터 아래 끝 표시까지는 서버 App\Services\Terms\TermsContent 와 **같은 규칙**이어야 한다.
   비교표(이 화면)와 회원 공지(서버 렌더)가 어긋나면 안 되기 때문이다.
   tests/Unit/TermsDiffTest.php 가 이 구간을 잘라 node 로 돌려 서버 결과와 대조한다.
   ═══════════════════════════════════════════════════════════════════════ */

/* ── 개정(안) 열: 현행 대비 바뀐 부분을 '취소선(기존) + 색(수정)' 으로 나란히 ──
   현행 열은 원문 그대로 두고, 개정(안) 열 한 곳에서 변경 전/후를 모두 읽을 수 있게 한다.
     예) 신청은 <del>3일</del><ins>7일</ins> 이내에 하여야 한다.
   3단계로 좁힌다.
     1) 항(clause)끼리 짝짓기 — 동일 항은 LCS 로, 나머지는 유사도로 매칭
     2) 짝지은 항을 어절 단위로 비교해 '교체된 구간'을 찾고
     3) 교체 구간 내부는 글자 단위로 다시 비교 (어절 하나가 통째로 물드는 것 방지)
   항이 통째로 추가/삭제됐으면(신설·삭제) 그 항 전체를 표시. */
// ── 개정 비교표 색 — 이 표는 html2canvas 로 **이미지로 내보내진다**(아래 compareCapture).
//    내보낸 그림은 테마와 무관하게 흰 종이 위에서 읽혀야 하므로 토큰을 쓰지 않고 라이트로 고정한다.
const DIFF_COLOR  = '#dc2626';   // 새로 들어간 내용
const DEL_COLOR   = '#8a94a6';   // 없어진 내용 (취소선과 함께)
const MOVE_COLOR  = '#2563eb';   // 내용은 그대로고 자리만 바뀐 항
const RENUM_COLOR = '#7c8598';   // 번호표기(1. → 1) → ①)만 바뀐 항 — 문구 개정이 아니다

/* 항 앞머리 번호표기 — `1.` `1)` `(1)` `①` `가.`
   조문을 재편하면 번호 체계가 통째로 밀리는데, 이걸 문구 수정과 같은 색으로 칠하면
   실제로는 그대로인 조가 전면 개정처럼 읽힌다. 그래서 번호는 따로 떼어 다르게 표시한다. */
const NUM_PREFIX_RE = /^\s*(?:\(\s*\d{1,2}\s*\)|\d{1,2}\s*[.)]|[가나다라마바사아자차카타파하]\s*[.)]|[①-⑳])\s*/;

// 항 → [앞머리 번호표기, 나머지 본문]. `1. 1) ①` 처럼 겹쳐 붙은 표기도 함께 떼어낸다.
function splitNum(s) {
    let rest = String(s == null ? '' : s), head = '';
    for (let k = 0; k < 3; k++) {
        const m = rest.match(NUM_PREFIX_RE);
        if (!m) break;
        head += m[0];
        rest = rest.slice(m[0].length);
    }
    return [head, rest];
}

// 번호표기를 뗀 뒤 정규화한 본문 — 짝짓기·'번호만 다른 항' 판별용
function stripNum(s) { return normClause(splitNum(s)[1]); }

// dp[i][j] = LCS(a[i..], b[j..]) 길이
function lcsMatrix(a, b) {
    const dp = Array.from({ length: a.length + 1 }, () => new Uint32Array(b.length + 1));
    for (let i = a.length - 1; i >= 0; i--) {
        for (let j = b.length - 1; j >= 0; j--) {
            dp[i][j] = a[i] === b[j] ? dp[i + 1][j + 1] + 1 : Math.max(dp[i + 1][j], dp[i][j + 1]);
        }
    }
    return dp;
}

// 공백을 토큰으로 보존해 재조합 시 원문이 그대로 복원되게 한다
function tokenize(s) {
    return String(s == null ? '' : s).split(/(\s+)/).filter(t => t !== '');
}

// ops 배열에 이어붙이기 — 같은 종류끼리는 한 덩어리로 묶어 태그 난립을 막는다
function pushOp(ops, type, t) {
    if (t === '') return;
    const last = ops[ops.length - 1];
    if (last && last.type === type) last.text += t; else ops.push({ type: type, text: t });
}

/* 배열 diff → 연속 구간 ops [{type:'eq'|'del'|'add', text}].
   교체 구간에서는 del 을 먼저 낸다 — 화면에 '기존(취소선) → 수정' 순서로 읽히게. */
function diffOps(a, b) {
    const dp = lcsMatrix(a, b);
    const ops = [];
    let i = 0, j = 0;
    while (i < a.length && j < b.length) {
        if (a[i] === b[j]) { pushOp(ops, 'eq', b[j]); i++; j++; }
        else if (dp[i + 1][j] >= dp[i][j + 1]) { pushOp(ops, 'del', a[i]); i++; }
        else { pushOp(ops, 'add', b[j]); j++; }
    }
    while (i < a.length) pushOp(ops, 'del', a[i++]);
    while (j < b.length) pushOp(ops, 'add', b[j++]);
    return ops;
}

// 한 항(old→new) → 개정(안) 열에 그릴 ops. 어절로 자리를 잡고 교체 구간만 글자 단위로 좁힌다.
function clauseOps(oldStr, newStr) {
    const ops = diffOps(tokenize(oldStr), tokenize(newStr));
    const out = [];
    for (let k = 0; k < ops.length; k++) {
        const op = ops[k], next = ops[k + 1];
        if (op.type === 'eq') { pushOp(out, 'eq', op.text); continue; }
        // del 과 add 가 붙어 있으면 '교체' — 내부를 글자 단위로 다시 비교 (서로게이트 안전)
        if (op.type === 'del' && next && next.type === 'add') {
            diffOps(Array.from(op.text), Array.from(next.text)).forEach(p => pushOp(out, p.type, p.text));
            k++; continue;
        }
        pushOp(out, op.type, op.text);   // 순수 추가 / 순수 삭제
    }
    return out;
}

// 글자 bigram 집합 (한 글자짜리는 그 글자 자체)
function bigrams(s) {
    const t = Array.from(String(s).replace(/\s+/g, ' ').trim());
    const g = new Set();
    if (t.length === 1) g.add(t[0]);
    for (let i = 0; i < t.length - 1; i++) g.add(t[i] + t[i + 1]);
    return g;
}

/* 두 bigram 집합의 [Dice, 포함도].
   Dice 는 길이가 비슷할 때, 포함도(짧은 쪽 기준 겹침)는 한쪽이 크게 축약됐을 때 쓸모가 있다. */
function simPair(A, B) {
    if (!A.size || !B.size) return [0, 0];
    let inter = 0;
    A.forEach(g => { if (B.has(g)) inter++; });
    return [(2 * inter) / (A.size + B.size), inter / Math.min(A.size, B.size)];
}

// 두 항의 Dice 유사도 0~1. 어절 LCS 로 재면 한 어절짜리 항이 항상 0 이 되어 오판한다.
function clauseSimilarity(x, y) {
    return simPair(bigrams(stripNum(x)), bigrams(stripNum(y)))[0];
}

/* 항 앞머리 정의어 — 번호·따옴표를 걷어낸 첫 낱말.
   약관 항은 '"용어"라 함은 …' / '용어 — …' 꼴이 대부분이라 이 낱말이 항의 신원 노릇을 한다. */
function headTerm(s) {
    const m = stripNum(s).replace(/^[\s"'“”‘’]+/, '').match(/^[가-힣A-Za-z0-9]{2,12}/);
    return m ? m[0] : '';
}

const PAIR_MIN_SIM      = 0.5;   // 길이가 비슷하면서 겹치는 항
const PAIR_MIN_CONTAIN  = 0.7;   // 짧게 축약된 항 (짧은 쪽 기준 겹침 비율)
const PAIR_TERM_MIN_SIM = 0.2;   // 정의어가 같을 때 — 용어가 근거를 대주므로 낮춰 잡는다

/* 한 구간의 현행 항 ↔ 개정 항 짝짓기 → Map(개정 항 idx → 현행 항 idx).

   개정 작업은 대개 긴 조문을 짧게 다시 쓰는 식이라 Dice 하나로는 짝을 놓친다
   (144자 → 48자면 살아남은 문구가 전부 겹쳐도 0.5 를 못 넘는다). 그래서 Dice·포함도·정의어를 함께 본다.
   확정은 점수 높은 쌍부터 전역으로 — 개정 항 순서대로 집어가면 짧은 신설항이 엉뚱한 현행항을
   먼저 채가서('발주' 가 '간편발주' 에 붙는 식) 정작 맞는 짝이 밀린다. */
function matchClauses(dels, adds) {
    const aHead = adds.map(a => headTerm(a));
    const aGram = adds.map(a => bigrams(stripNum(a)));

    const cand = [];
    dels.forEach((d, di) => {
        const dHead = headTerm(d), dGram = bigrams(stripNum(d));
        adds.forEach((a, ai) => {
            const [dice, contain] = simPair(dGram, aGram[ai]);
            const head = dHead !== '' && dHead === aHead[ai];
            if (dice < PAIR_MIN_SIM && contain < PAIR_MIN_CONTAIN
                && !(head && dice >= PAIR_TERM_MIN_SIM)) return;
            cand.push({ head: head ? 1 : 0, score: Math.max(dice, contain), di: di, ai: ai });
        });
    });
    cand.sort((x, y) => (y.head - x.head) || (y.score - x.score));

    const mate = new Map(), usedDel = new Set();
    cand.forEach(c => {
        if (usedDel.has(c.di) || mate.has(c.ai)) return;
        usedDel.add(c.di);
        mate.set(c.ai, c.di);
    });
    return mate;
}

// 비교용 정규화 — 공백 차이만으로 '다른 항'이 되지 않게
function normClause(s) {
    return String(s == null ? '' : s).replace(/\s+/g, ' ').trim();
}

/* 항 단위 LCS → [{type:'same'|'del'|'add', text}] (어절용 diffOps 와 달리 원소를 합치지 않는다).
   교체 구간에서 del 을 먼저 내는 것까지 서버(TermsContent::lcsOps)와 같아야 결과가 어긋나지 않는다. */
function lcsItems(a, b) {
    const dp = lcsMatrix(a, b);
    const ops = [];
    let i = 0, j = 0;
    while (i < a.length && j < b.length) {
        if (a[i] === b[j]) { ops.push({ type: 'same', text: a[i] }); i++; j++; }
        else if (dp[i + 1][j] >= dp[i][j + 1]) { ops.push({ type: 'del', text: a[i] }); i++; }
        else { ops.push({ type: 'add', text: b[j] }); j++; }
    }
    while (i < a.length) ops.push({ type: 'del', text: a[i++] });
    while (j < b.length) ops.push({ type: 'add', text: b[j++] });
    return ops;
}

/* 짝지은 항 뒤에 이어지는 '짝 없는 항'을 붙여 보며 상대 항과 더 닮아지면 흡수한다.
   항이 나뉘거나(분할) 합쳐진(병합) 것을 한 쌍으로 되돌려, 글자는 그대로인데
   '수정 + 신설 + 신설' 세 건으로 갈라져 보이는 것을 막는다. */
function absorb(seq, seqPos, text, taken, from, other) {
    let acc = text.get(from), best = clauseSimilarity(acc, other);
    const eaten = [];
    for (let k = seqPos.get(from) + 1; k < seq.length; k++) {
        const i = seq[k];
        if (!text.has(i) || taken.has(i)) break;      // 안 바뀐 항이거나 이미 임자가 있는 항 — 여기서 멈춘다
        const t = normClause(acc + ' ' + text.get(i));
        const s = clauseSimilarity(t, other);
        if (s <= best) break;
        acc = t; best = s; eaten.push(i);
    }
    return [acc, eaten];
}

/* 항 배열 정렬 → [{old, new, same, moved, split, merged}].
   old=null 이면 신설된 항, new=null 이면 삭제된 항.
   짝짓기는 조 전체를 한 풀로 놓고 한다 — 같은 항 사이 구간 안에서만 보면 자리를 옮긴 항을 놓친다. */
function alignClauses(a, b) {
    const lcs = lcsItems(a, b);
    const dels = new Map(), adds = new Map(), curSeq = [], drfSeq = [];
    lcs.forEach((o, i) => {
        if (o.type === 'same') { curSeq.push(i); drfSeq.push(i); }
        else if (o.type === 'del') { dels.set(i, o.text); curSeq.push(i); }
        else { adds.set(i, o.text); drfSeq.push(i); }
    });

    const dk = [...dels.keys()], ak = [...adds.keys()];
    const pair = new Map(), mated = new Set();
    matchClauses([...dels.values()], [...adds.values()]).forEach((di, ai) => {
        pair.set(ak[ai], dk[di]);
        mated.add(dk[di]);
    });

    const pos = arr => new Map(arr.map((v, k) => [v, k]));
    const drfPos = pos(drfSeq), curPos = pos(curSeq);
    const before = new Map(), after = new Map(), eatenAdd = new Set(), eatenDel = new Set();
    pair.forEach((di, ai) => {
        const [a2, ea] = absorb(drfSeq, drfPos, adds, new Set([...pair.keys(), ...eatenAdd]), ai, dels.get(di));
        ea.forEach(k => eatenAdd.add(k));
        const [b2, eb] = absorb(curSeq, curPos, dels, new Set([...mated, ...eatenDel]), di, a2);
        eb.forEach(k => eatenDel.add(k));
        after.set(ai, a2); before.set(ai, b2);
    });

    const out = [];
    lcs.forEach((o, i) => {
        if (o.type === 'same') { out.push({ old: o.text, new: o.text, same: true }); return; }
        if (o.type === 'del') {
            if (!mated.has(i) && !eatenDel.has(i)) out.push({ old: o.text, new: null });
            return;
        }
        if (eatenAdd.has(i)) return;
        if (!pair.has(i)) { out.push({ old: null, new: o.text }); return; }
        const di = pair.get(i);
        // 짝이 안 바뀐 항을 건너뛰어 붙었다면 자리가 옮겨진 것
        const moved = lcs.slice(Math.min(di, i), Math.max(di, i)).some(x => x.type === 'same');
        out.push({
            old:    before.get(i),
            new:    after.get(i),
            moved:  moved,
            split:  normClause(after.get(i))  !== normClause(o.text),
            merged: normClause(before.get(i)) !== normClause(dels.get(di)),
        });
    });
    return out;
}

/* 개정(안) 열 HTML — 없어진 글은 취소선으로 남기고 그 뒤에 새 글을 붙인다.
   실제로 문구가 바뀐 것만 수정색으로 칠하고, 자리만 바뀐 항은 [순서변경],
   번호표기만 밀린 항은 [번호변경], 항이 나뉘거나 합쳐지기만 한 것은 [항분할]·[항병합] 으로 갈라 표시한다. */
function clausesDiff(cur, drf) {
    const curCl = (cur && cur.clauses) ? cur.clauses : [];
    const drfCl = (drf && drf.clauses) ? drf.clauses : [];
    if (!curCl.length && !drfCl.length) return '<span style="color:#bbb">-</span>';

    const del   = (s) => `<span style="color:${DEL_COLOR};text-decoration:line-through">${escHtml(s)}</span>`;
    const add   = (s) => `<span style="color:${DIFF_COLOR}">${escHtml(s)}</span>`;
    const renum = (s) => `<span style="color:${RENUM_COLOR}">${escHtml(s)}</span>`;
    const tag   = (s, c) => `<span style="color:${c};font-size:13px;font-weight:bold">[${s}]</span> `;
    const paint = { eq: escHtml, del: del, add: add };
    const inline = (o, n) => clauseOps(o, n).map(p => paint[p.type](p.text)).join('');

    return alignClauses(curCl, drfCl).map(p => {
        if (p.same)        return escHtml(p.new);
        if (p.new == null) return del(p.old);   // 삭제된 항 — 통째로 취소선
        if (p.old == null) return add(p.new);   // 신설된 항 — 통째로 표시색

        const [oNum, oBody] = splitNum(p.old);
        const [nNum, nBody] = splitNum(p.new);
        const kept    = normClause(p.old) === normClause(p.new);              // 완전히 동일
        const numOnly = !kept && normClause(oBody) === normClause(nBody);     // 번호표기만 다름

        // 번호가 밀린 것뿐인 앞머리는 수정색으로 칠하지 않는다 — 뒤 본문의 실제 개정만 눈에 남게
        const html = (kept || numOnly)               ? escHtml(p.new)
                   : (oNum !== nNum && oNum && nNum) ? renum(nNum) + inline(oBody, nBody)
                   : inline(p.old, p.new);

        const parts = [];
        if (p.moved) parts.push('순서변경');
        if (p.split && p.merged) parts.push('항재구성');
        else if (p.split)  parts.push('항분할');
        else if (p.merged) parts.push('항병합');
        if (numOnly) parts.push('번호변경');
        else if (!kept && parts.length) parts.push('수정');   // 형식 변경과 문구 수정이 겹친 경우
        if (!parts.length) return html;                       // 순수 문구 수정 — 배지 없이 색으로만
        return tag(parts.join('·'), p.moved ? MOVE_COLOR : RENUM_COLOR) + html;
    }).join('<br>');
}

/* ══ terms-diff:end ═══════════════════════════════════════════════════════ */

function escHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

// 날짜 압축 표기: 오늘이면 시:분:초, 오늘 이전이면 날짜(YYYY-MM-DD)만
function fmtCompactDate(v) {
    if (!v) return '-';
    const s = String(v);
    const datePart = s.slice(0, 10);
    const n = new Date();
    const today = `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, '0')}-${String(n.getDate()).padStart(2, '0')}`;
    return datePart === today ? (s.slice(11, 19) || datePart) : datePart;
}

// ── 숫자 포맷 ──
function number_format(n) {
    return parseInt(n).toLocaleString();
}

/* ══════════════════════════════════════════════════════════
 *  통합 반영 (개정 회차)
 * ══════════════════════════════════════════════════════════ */
let BATCH_TERMS = [];   // selectable 약관 목록 (현재 서비스)

// 약관 행 체크 시 강조(.row-on)
function batchRowToggle(el) {
    $(el).closest('tr').toggleClass('row-on', el.checked);
}

// 헤더 '전체' — 목록에 올라온 약관을 한 번에 선택/해제
function batchToggleAll(el) {
    $('#bSelectBody .b-chk').prop('checked', el.checked).each(function () { batchRowToggle(this); });
    batchSyncAll();
    batchSummary();
}

// 개별 체크 → 헤더 상태 동기화. 일부만 골랐으면 중간(indeterminate) 표시.
function batchSyncAll() {
    const $chk = $('#bSelectBody .b-chk');
    const n = $chk.length, k = $chk.filter(':checked').length;
    $('#bChkAll').prop({ checked: n > 0 && k === n, indeterminate: k > 0 && k < n, disabled: n === 0 });
}

// ── 1) 회차로 묶을 약관 로드 ──
function batchLoadSelectable() {
    const service = $('#bServiceSel').val();
    $.post('/adm/ajax/terms/batch/selectable', { service }, function (res) {
        BATCH_TERMS = (res && res.data) || [];
        renderBatchSelect();
    });
}

function renderBatchSelect() {
    const $b = $('#bSelectBody').empty();
    if (!BATCH_TERMS.length) {
        $b.html('<tr><td colspan="8" class="text-muted text-center" style="padding:18px;">예정 버전이 있는 약관이 없습니다. [버전관리]에서 예정안을 먼저 만들어주세요.</td></tr>');
        batchSyncAll();
        batchSummary();
        return;
    }
    const svc = $('#bServiceSel').val();
    const svcCls = svc === 'BD' ? 'svc-evil' : 'svc-jang';
    const svcLbl = svc === 'BD' ? '악덕알리미' : '장비불러';
    BATCH_TERMS.forEach(function (t) {
        $b.append(
            '<tr data-tn="' + t.num + '">' +
            '<td class="chk-cell"><input type="checkbox" class="b-chk" data-tm-change="batchRow"></td>' +
            '<td class="nm">' + esc(t.name) + '</td>' +
            '<td><span class="svc-badge ' + svcCls + '">' + svcLbl + '</span></td>' +
            '<td>' + (t.from_ver_no ? 'v' + t.from_ver_no : '신규') + '</td>' +
            '<td>v' + t.to_ver_no + '</td>' +
            '<td>' + (t.change_cnt || 0) + '개 조항</td>' +
            '<td><span class="st-pill st-ready">예정</span></td>' +
            '<td><button type="button" class="abtn" data-tm="batchCompare" data-n="' + t.num + '" data-n2="' + t.to_ver_num + '">미리보기</button></td>' +
            '</tr>'
        );
    });
    batchSyncAll();
    batchSummary();
}

function batchCheckedNums() {
    return $('#bSelectBody tr').filter(function () {
        return $(this).find('.b-chk').is(':checked');
    }).map(function () { return $(this).data('tn'); }).get();
}

// ── 약관별 변경예정안 비교(모달) ──
function batchCompare(termsNum, toVer) {
    $.post('/adm/ajax/terms/batch/compare', { terms_num: termsNum, to_ver_num: toVer }, function (res) {
        if (!res.result) { alert(res.message || '비교 실패'); return; }
        let html = '<div style="max-height:calc(60vh / var(--adm-zoom, 1)); overflow:auto;">';
        (res.rows || []).forEach(function (r) {
            html += '<div style="padding:8px 0; border-bottom:1px solid #eee;">' +
                '<b>' + esc(r.no + ' ' + r.title) + '</b> <span class="badge">' + esc(r.status) + '</span>' +
                (r.current ? '<div class="text-muted" style="margin-top:4px;">변경 전: ' + esc((r.current.clauses || []).join(' / ')) + '</div>' : '') +
                (r.draft   ? '<div style="margin-top:4px;">변경 후: ' + esc((r.draft.clauses || []).join(' / ')) + '</div>' : '') +
                '</div>';
        });
        html += '</div>';
        $j.Ui.JBModal.html('batchCompareModal', html, '변경예정안 비교', { width: '720px' });
    });
}

// ── 2) 30일 검증 ──
function batchCheckPeriod() {
    const post = $('#bPostDate').val(), apply = $('#bApplyDate').val();
    if (!post || !apply) { $('#bPeriodBadge').text('').attr('class', 'mini-note'); return; }
    $.post('/adm/ajax/terms/batch/check-period', { post_date: post, apply_date: apply }, function (res) {
        const mark = res.ok ? '✔ ' : '⚠ ';
        const txt = mark + res.days + '일 (' + (res.ok ? '충족' : '미달') + ')';
        $('#bPeriodBadge').text(txt).attr('class', 'mini-note' + (res.ok ? '' : ' bad'));
    });
    // 팝업 노출기간 기본값 = 게시일~시행일
    // 팝업 노출기간 기본값 = 게시일~시행일. 모비스크롤이면 인스턴스로 세팅(내부 선택일까지 동기화).
    const setDate = (sel, v) => {
        if (window.mobiscroll) { try { mobiscroll.getInst($(sel)[0]).setVal(v); return; } catch (e) {} }
        $(sel).val(v);
    };
    if (!$('#bPopupStart').val()) setDate('#bPopupStart', post);
    if (!$('#bPopupEnd').val())   setDate('#bPopupEnd', apply);
    batchSummary();
}

// ── 5) 헤드라인 자동 생성 ──
function batchAutoHeadline() {
    const nums = batchCheckedNums();
    if (!nums.length) { alert('약관을 먼저 선택해주세요.'); return; }
    // 선택 약관들의 변경 유형 집계 (change_cnt>0 이면 개정 포함). 단순 규칙: 신규 여부로 추가, 나머지 수정.
    let hasNew = false, hasMod = false;
    BATCH_TERMS.forEach(function (t) {
        if (nums.indexOf(t.num) < 0) return;
        if (!t.from_ver_no) hasNew = true; else hasMod = true;
    });
    const parts = [];
    if (hasMod) parts.push('수정');
    if (hasNew) parts.push('추가');
    $('#bHeadline').val('약관이 ' + (parts.join('·') || '변경') + '됩니다');
}

// ── 요약바 (다크 바) ──
function batchSummary() {
    const nums = batchCheckedNums();
    const post = $('#bPostDate').val() || '-', apply = $('#bApplyDate').val() || '-';
    const reflect = $('input[name=bReflect]:checked').val() === 'NOW' ? '현행 바로 반영' : '예정일 반영';
    $('#bSummary').html(nums.length
        ? '선택 <b>' + nums.length + '개</b> · 시행 <b>' + esc(apply) + '</b> · 공지 <b>' + esc(post) + '</b> · ' + reflect
        : '<span style="color:#aaa;">묶을 약관을 선택하세요.</span>');
}

// ── 팝업 미리보기 ──
function batchPopupPreview() {
    const nums = batchCheckedNums();
    if (!nums.length) { alert('약관을 먼저 선택해주세요.'); return; }
    $.post('/adm/ajax/terms/batch/popup-preview', {
        service: $('#bServiceSel').val(),
        terms_nums: nums,
        post_date: $('#bPostDate').val(),
        apply_date: $('#bApplyDate').val(),
    }, function (res) {
        if (!res.result) { alert(res.message || '미리보기 실패'); return; }
        // 실제 모바일 팝업과 동일한 마크업을 모바일 폭 프레임에 넣어 보여준다.
        const frame = '<div style="max-width:360px; margin:0 auto; border:1px solid #ddd; border-radius:10px; overflow:hidden;">' +
            '<div style="padding:14px 16px; max-height:calc(70vh / var(--adm-zoom, 1)); overflow:auto;" class="terms-notice-preview">' +
            (res.html || '') + '</div></div>';
        $j.Ui.JBModal.html('batchPopupPreviewModal', frame, '📱 팝업 미리보기', { width: '440px' });
    });
}

// ── 반영 · 등록 (30일 검증 확인창) ──
function batchPublish() {
    const nums = batchCheckedNums();
    if (!nums.length) { alert('약관을 먼저 선택해주세요.'); return; }
    const post = $('#bPostDate').val(), apply = $('#bApplyDate').val();
    if (!post || !apply) { alert('공지 게시일과 시행 예정일을 입력해주세요.'); return; }

    const doPublish = function () {
        $.post('/adm/ajax/terms/batch/publish', {
            service: $('#bServiceSel').val(),
            title: $('#bHeadline').val() || '약관 개정 안내',
            terms_nums: nums,
            post_date: post,
            apply_date: apply,
            reflect_type: $('input[name=bReflect]:checked').val(),
            popup_start: $('#bPopupStart').val() || post,
            popup_end: $('#bPopupEnd').val() || apply,
            // 약관 팝업의 다시보지않기는 서버가 무조건 영구(NEVER)로 고정 — 여기선 안 보냄
        }, function (res) {
            if (!res.result) { alert(res.message || '발행 실패'); return; }
            alert('회차 #' + res.batch_num + ' 발행 완료 (공지글 #' + res.post_id + ')');
            // 발행 완료 → 예정이력 탭으로 이동
            location.href = '/adm/config/terms?tab=history';
        });
    };

    // 30일 미달이면 확인창
    $.post('/adm/ajax/terms/batch/check-period', { post_date: post, apply_date: apply }, function (res) {
        if (res.ok) { doPublish(); return; }
        if (confirm('게시일 기준 30일 요건 미달(' + res.days + '일).\n불리·중대 변경은 30일 전 공지가 필요합니다.\n그래도 게시하시겠습니까?')) {
            doPublish();
        }
    });
}

function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
}

/* ══════════════════════════════════════════════════════════
 *  예정이력관리 (개정 회차)
 * ══════════════════════════════════════════════════════════ */
let $historyTable = null;

const BATCH_STATUS = {
    SCHEDULED: { label: '예정',     cls: 'badge-upcoming' },
    APPLIED:   { label: '반영완료', cls: 'badge-current' },
    CANCELED:  { label: '취소됨',   cls: 'badge-old' },
};
const POPUP_STATE_CLS = {
    '노출중':   'badge-active',
    '노출대기': 'badge-upcoming',
    '기간만료': 'badge-old',
    '숨김':     'badge-old',
    '팝업해제': 'badge-old',
    '미발행':   'badge-inactive',
};

// 탭 진입 로드는 termsTab('history') 이 호출.
function loadHistoryTable() {
    if ($historyTable) { $historyTable.ajax.reload(); return; }
    $historyTable = $('#historyTable').DataTable({
        ajax: { url: '/adm/ajax/terms/batch/list', type: 'POST' },
        order: [[0, 'desc']],
        autoWidth: false,
        columnDefs: [{ targets: [0, 2, 3, 4, 5, 6, 7], className: 'text-center' }],
        columns: [
            { title: '회차', data: 'num', width: '55px', render: function (d) { return '#' + d; } },
            { title: '제목', data: 'title', width: '38%' },
            { title: '서비스', data: 'service', width: '90px', render: function (d) {
                return ({ BD: '악덕알리미', MC: '머큐리', IP: '이노페이' })[d] || '장비불러';
            } },
            { title: '약관수', data: 'terms_cnt', width: '70px', render: function (d) { return d + '개'; } },
            { title: '시행일', data: 'apply_date', width: '110px' },
            { title: '회차상태', data: 'status', width: '90px', render: function (d) {
                const s = BATCH_STATUS[d] || { label: d, cls: '' };
                return '<span class="badge ' + s.cls + '">' + s.label + '</span>';
            } },
            { title: '공지·팝업', data: 'popup_state', width: '95px', render: function (d) {
                return '<span class="badge ' + (POPUP_STATE_CLS[d] || '') + '">' + esc(d) + '</span>';
            } },
            { title: '관리', data: null, width: '210px', orderable: false, render: function (d, t, row) {
                let btns = '<button type="button" class="btn btn-default btn-xs" data-tm="historyDetail" data-n="' + row.num + '">상세</button>';
                if (row.post_id) {
                    btns += ' <button type="button" class="btn btn-default btn-xs" data-tm="historyPreview" data-n="' + row.num + '">미리보기</button>';
                }
                if (row.status === 'SCHEDULED') {
                    btns += ' <button type="button" class="btn btn-danger btn-xs" data-tm="historyCancel" data-n="' + row.num + '">예정 취소</button>';
                }
                return btns;
            } },
        ],
    });
}

// ── 회차 상세 ──
function historyDetail(batchNum) {
    $.post('/adm/ajax/terms/batch/detail', { batch_num: batchNum }, function (res) {
        if (!res.result) { alert(res.message || '조회 실패'); return; }
        const b = res.batch;
        let html = '<div style="font-size:16px;">';
        html += '<table class="table table-sm" style="margin-bottom:12px;">' +
            '<tr><th style="width:100px;">회차</th><td>#' + b.num + '</td></tr>' +
            '<tr><th>제목</th><td>' + esc(b.title) + '</td></tr>' +
            '<tr><th>공지 게시일</th><td>' + esc(b.post_date) + '</td></tr>' +
            '<tr><th>시행 예정일</th><td>' + esc(b.apply_date) + '</td></tr>' +
            '<tr><th>반영 방식</th><td>' + (b.reflect_type === 'NOW' ? '현행 바로 반영' : '예정일 반영') + '</td></tr>' +
            '<tr><th>공지글</th><td>' + (b.post_id ? '#' + b.post_id : '미발행') + '</td></tr>' +
            '</table>';
        html += '<b>묶인 약관</b><table class="table table-bordered table-sm" style="margin-top:6px;"><thead><tr><th>약관</th><th style="width:120px;">변경 전 → 후</th></tr></thead><tbody>';
        (res.items || []).forEach(function (it) {
            html += '<tr><td>' + esc(it.name) + '</td><td>ver#' + (it.from_ver_num || '신규') + ' → ver#' + it.to_ver_num + '</td></tr>';
        });
        html += '</tbody></table></div>';
        $j.Ui.JBModal.html('historyDetailModal', html, '회차 #' + batchNum + ' 상세', { width: '620px' });
    });
}

// ── 팝업 미리보기 — 실제 발행된 공지글 본문을 모바일 폭으로 (실제 팝업과 동일) ──
function historyPreview(batchNum) {
    $.post('/adm/ajax/terms/batch/detail', { batch_num: batchNum }, function (res) {
        if (!res.result) { alert(res.message || '조회 실패'); return; }
        if (!res.post) { alert('발행된 공지글이 없습니다.'); return; }
        const frame = '<div style="max-width:360px; margin:0 auto; border:1px solid #ddd; border-radius:10px; overflow:hidden;">' +
            '<div style="padding:14px 16px; max-height:calc(70vh / var(--adm-zoom, 1)); overflow:auto;" class="terms-notice-preview">' +
            (res.post.body || '') + '</div></div>';
        $j.Ui.JBModal.html('historyPreviewModal', frame, '📱 팝업 미리보기', { width: '440px' });
    });
}

// ── 예정 취소 ──
function historyCancel(batchNum) {
    if (!confirm('예정 회차 #' + batchNum + ' 을 취소합니다.\n시행 전환이 취소되고, 사전 게시된 공지·팝업도 함께 내려갑니다.\n계속하시겠습니까?')) return;
    $.post('/adm/ajax/terms/batch/cancel', { batch_num: batchNum }, function (res) {
        if (!res.result) { alert(res.message || '취소 실패'); return; }
        alert('회차 #' + batchNum + ' 이 취소되었습니다.');
        if ($historyTable) $historyTable.ajax.reload();
    });
}

// ── JS 가 그리는 버튼의 동작 — data-tm="이름" (+ data-n·data-n2 숫자 인자, data-modal 모달 id) ──
const num = (el, k = 'n') => Number(el.dataset[k]);
const CLICK = {
    selectTerms: (el) => selectTerms(num(el)),
    editMaster: (el) => editMaster(num(el)),
    showMasterModal: () => showMasterModal(),
    viewVersion: (el) => viewVersion(num(el)),
    reloadConsentModal: () => reloadConsentModal(),
    resetConsentModal: () => { $('#cm_kw').val(''); $('#cm_result').val(''); reloadConsentModal(); },
    selectConsentTerms: (el) => selectConsentTerms(num(el)),
    copyTermsText: (el) => copyTermsText(el),
    editContent: (el) => editContent(num(el)),
    showCompare: (el) => showCompare(num(el)),
    applyVersion: (el) => applyVersion(num(el)),
    deleteVersion: (el) => deleteVersion(num(el)),
    showVersionModal: () => showVersionModal(),
    closeModal: (el) => $j.Ui.JBModal.close(el.dataset.modal),
    saveMaster: () => saveMaster(),
    saveVersion: () => saveVersion(),
    addStructuredItem: () => addStructuredItem(),
    toggleGuide: (el) => $(el).closest('.ec-guide').toggleClass('open'),
    addArticle: () => addArticle(),
    previewContent: () => previewContent(),
    saveContentAsDraft: () => saveContentAsDraft(),
    saveContent: () => saveContent(),
    removeArticle: (el) => removeArticle(num(el)),
    selectArticle: (el) => selectArticle(num(el)),
    removeStructuredItem: (el) => $(el).closest('.ec-s-item').remove(),
    downloadCompareImage: (el) => downloadCompareImage(el),
    batchCompare: (el) => batchCompare(num(el), num(el, 'n2')),
    historyDetail: (el) => historyDetail(num(el)),
    historyPreview: (el) => historyPreview(num(el)),
    historyCancel: (el) => historyCancel(num(el)),
};
const CHANGE = {
    updateVersionCurrentNote: () => updateVersionCurrentNote(),
    toggleContentType: () => toggleContentType(),
    batchRow: (el) => { batchRowToggle(el); batchSyncAll(); batchSummary(); },
};

export default class Terms {
    initialize() {
        // JS 가 그리는 버튼·칸 — data-tm="동작" 을 위임으로 받는다 (아래 CLICK·CHANGE 표)
        $(document).on('click', '[data-tm]', function (e) {
            const fn = CLICK[this.dataset.tm];
            if (!fn) return;
            if (this.tagName === 'A') e.preventDefault();
            fn(this);
        });
        $(document).on('change', '[data-tm-change]', function () {
            const fn = CHANGE[this.dataset.tmChange];
            if (fn) fn(this);
        });

        // blade 마크업에서 옮긴 핸들러
        $('#btnConsentLog').on('click', () => showSelectedConsentLog());
        $('#ct_kw').on('keypress', (e) => { if (e.key === 'Enter') reloadConsentTab(); });
        $('#btnConsentSearch').on('click', () => reloadConsentTab());
        $('#btnConsentReset').on('click', () => { $('#ct_kw').val(''); $('#ct_result').val(''); reloadConsentTab(); });
        $('#bChkAll').on('change', function () { batchToggleAll(this); });
        $('#btnAutoHeadline').on('click', () => batchAutoHeadline());
        $('#btnBatchPreview').on('click', () => batchPopupPreview());
        $('#btnBatchPublish').on('click', () => batchPublish());

        // ── 아래는 예전 blade 인라인에서 최상위로 돌던 것 (순서 그대로) ──
        $(function () {
            loadTermsTable();
            // 활성 탭은 상단 1층 탭바의 ?tab= 로 결정된다. 해당 패널의 지연 로드만 여기서 트리거.
            const tab = new URLSearchParams(location.search).get('tab') || 'version';
            if (tab === 'batch')   batchLoadSelectable();
            if (tab === 'history') loadHistoryTable();
            if (tab === 'consent') loadConsentTermsTable();
        });

        $(document).on('input.termsArticleLabel', '#ec_articles .a-no, #ec_articles .a-title', renderArticlesList);

        $(function () {
            // 탭 진입 시 로드는 termsTab() 이 담당. 여기선 폼 입력 바인딩만.
            $('#bServiceSel').on('change', batchLoadSelectable);

            // 달력 — 모비스크롤 (관리자 레이아웃에 전역 로드됨). 게시일/시행일 변경 시 30일 검증.
            if (window.mobiscroll) {
                $('#bPostDate, #bApplyDate').mobiscroll().datepicker({
                    controls: ['calendar'], dateFormat: 'YYYY-MM-DD', locale: mobiscroll.localeKo, buttons: [],
                    // onChange 는 input 값 동기화 전에 발화 → 다음 틱에 읽어 이전값 문제 방지.
                    onChange: function () { setTimeout(batchCheckPeriod, 0); },
                });
                $('#bPopupStart, #bPopupEnd').mobiscroll().datepicker({
                    controls: ['calendar'], dateFormat: 'YYYY-MM-DD', locale: mobiscroll.localeKo, buttons: [],
                });
            }

            // 반영 방식 라디오 카드 — 클릭 시 .on 토글
            $(document).on('change', 'input[name=bReflect]', function () {
                $('.batch-wrap .radio-card').removeClass('on');
                $(this).closest('.radio-card').addClass('on');
                batchSummary();
            });
        });
    }
}
